// Enforces cross-method rules between Pay by Bank, Cards, and Amex.
//
// Rule 1: Amex requires Cards (enabling Amex enables Cards; disabling
//         Cards disables Amex).
// Rule 2: Cards and Pay by Bank can't both be off (disabling either
//         while the other is off flips the other back on).
//
// Pass the config already updated with the caller's change plus the key
// that changed. Returns a new config with the rules enforced. Card key
// name differs between contexts (`allowCard` vs `allowCards`), so it can
// be overridden.
export function applyPaymentMethodRules(
  state,
  changedKey,
  {
    openBankingKey = "allowOpenBanking",
    cardKey = "allowCard",
    amexKey = "allowAmex",
  } = {},
) {
  const next = { ...state };
  const newValue = next[changedKey];

  if (changedKey === amexKey && newValue) next[cardKey] = true;
  if (changedKey === cardKey && !newValue) next[amexKey] = false;

  if (changedKey === cardKey && !newValue && !next[openBankingKey]) {
    next[openBankingKey] = true;
  }
  if (changedKey === openBankingKey && !newValue && !next[cardKey]) {
    next[cardKey] = true;
  }

  return next;
}
